import React from 'react';

const Index = ({ firstHeading, secondHeading, _class, _secondHeading, subTitle, headingThree, headingTwo, headingOne, _miniClass }) => {
  const HeadingComponent = headingOne ? 'h1' :
                           headingTwo ? 'h2' :
                           headingThree ? 'h3' :
                           'h2';  

  return (
    <div className={`title text-center ${_class}`}>
      {firstHeading && (
        <span
        className={`miniheading ${_miniClass}`}
          data-aos="zoom-in"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
          dangerouslySetInnerHTML={{ __html: firstHeading }}
        />
      )}
      {secondHeading && (
        <HeadingComponent
          className={`heading primary-color mb-3 ${_secondHeading}`}
          data-aos="flip-down"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
          dangerouslySetInnerHTML={{ __html: secondHeading }}
        />
      )}
      {subTitle && (
        <p
          className="col-12 float-start m-0"
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="500"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"
        >
          {subTitle}
        </p>
      )}
    </div>
  );
};

export default Index;
